import apiPaths from '../api-paths';

export default {
  showFull(id) {
    return axios.get(`${ apiPaths.CRM }/pricelist/full/${ id }`);
  },
  createFromCopy(data) {
    return axios.post(`${ apiPaths.CRM }/pricelist/create-from-copy`, data);
  },
};
